import type { OpsCaseItem } from '@utazzo/shared';

/**
 * "DEL Airport → Hotel", or for a transfer with no endpoints (an "any
 * transfers within city" day pass) the city it covers: "Within Singapore".
 */
export const transferRouteLabel = (
  item: Pick<OpsCaseItem, 'fromLocation' | 'toLocation' | 'details'>,
): string => {
  // A fixed departure's vehicle supplement covers the whole trip, not a leg.
  if (item.details?.fdSupplement) return 'Whole trip (package)';
  const t = item.details?.transfer ?? null;
  const from = t?.fromLocation ?? item.fromLocation ?? null;
  const to = t?.toLocation ?? item.toLocation ?? null;
  if (from && to) return `${from} → ${to}`;
  if (from || to) return (from ?? to) as string;
  if (t?.cityName) return `Within ${t.cityName}`;
  return '-';
};
